<template>
  <div class="c-equipmentArchive__colCards">
    <div class="c-equipmentArchive__results c-equipmentArchive__results--mobile">
      <div class="c-equipmentArchive__results__number">
        <span></span>
      </div>
    </div>
    <div class="c-equipmentArchive__cards">
      <a v-bind:href="equipment.permalink" class="c-equipCards"  v-for="equipment in equipments"  v-bind:key="equipment.post_id">
        <card :equipment="equipment"></card>
      </a>
      <div v-if="count < 1" class="Editable">
        <p>{{ default_filter_message }}</p>
      </div>
    </div>
    <pagination v-if="count>limit" v-on="$listeners" :current_page="current_page" :limit="limit" :count="count"></pagination>
  </div>
</template>


<script>
  import Card from "./Card";
  import Pagination from "./Pagination";
  export default {
    name: "CardsResult",
    components: {
      Card, Pagination
    },
    props : ['equipments','count','current_page','limit'],
    data() {
      return {
        // translation
        default_filter_message: window.Store.translate_strings ? window.Store.translate_strings.default_filter_message : '',
      }
    }
  }
</script>

<style scoped>

</style>
